export const permissionsSchema = {
  viewAdminNavCode: value => typeof value === 'number' && value > 0 && value < 4,
  crudMasterAdminCode: value => typeof value === 'number' && value > 0 && value < 4,
  crudAdminCode: value => typeof value === 'number' && value > 0 && value < 4,
  crudStandardCode: value => typeof value === 'number' && value > 0 && value < 4,
  crudLimitedCode: value => typeof value === 'number' && value > 0 && value < 4,
  viewReportsCode: value => typeof value === 'number' && value > 0 && value < 4,
  viewCommentsCode: value => typeof value === 'number' && value > 0 && value < 4,
  viewDocumentsCode: value => typeof value === 'number' && value > 0 && value < 4,
  viewOtherCode: value => typeof value === 'number' && value > 0 && value < 4
}
